
export default [
    "IconBtn",
    "IconSvg/IconSvg",
    "Img/VBluredImg",
    // VImg,
    "VSkeleton",
    "VSwitch",
    "VCardList",
    "VCard",
    "VSection",
    "Input/ui/VInput",
	"Modal/ui/VModal",
	"Button/ui/VButton",
	"Tag/VTag",
	"Tag/VTags",

    "GradualText/ui/VGradualText",
    "GradualText/ui/VNestedElements",
]
